const ITEMS = [
  "Desde 2010",
  "Insulfilm Residencial",
  "Insulfilm Comercial",
  "Insulfilm Automotivo",
  "Películas de Segurança",
  "Películas Decorativas",
  "Rio de Janeiro",
  "Orçamento pelo WhatsApp",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-navy/10 bg-mist py-3 md:py-5" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-8 md:gap-16">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 whitespace-nowrap md:gap-16">
            <span className="font-display text-sm font-medium tracking-wide text-navy/70 md:text-lg">{item}</span>
            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" className="shrink-0">
              <path d="M7 0C7 5 3 7 0 7c3 1 7 3 7 7 0-4 4-6 7-7-3 0-7-2-7-7z" fill="#00B4D8" opacity="0.9" transform="translate(0 2)" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
